export enum TrackingLineConstants {
  GET_ORDER_LINES_REQUEST = 'GET_ORDER_LINES_REQUEST',
  GET_ORDER_LINES_SUCCESS = 'GET_ORDER_LINES_SUCCESS',
  GET_ORDER_LINES_FAILURE = 'GET_ORDER_LINES_FAILURE',
  RESET_STATE = 'RESET_STATE',
}
